"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResuppliesByArticlesByDays = void 0;
var dateToStringKey_1 = require("../dateToStringKey");
var dayjs_1 = __importDefault(require("dayjs"));
function getResuppliesByArticlesByDays(resupplies, from) {
    if (from === void 0) { from = new Date(); }
    var maxDateKey = dateToStringKey_1.dateToStringKey(new Date());
    var resuppliesByArticleByDay = resupplies.reduce(function (acc, _a) {
        var ARKTCOMART = _a.ARKTCOMART, localProductionTime = _a.localProductionTime, scheduledResupplies = _a.scheduledResupplies, productionOrders = _a.productionOrders, supplierOrders = _a.supplierOrders;
        if (localProductionTime) {
            var date = new Date(from);
            var dateKey = dateToStringKey_1.dateToStringKey(dayjs_1.default(date).add(localProductionTime.days, "day").toDate());
            if (!acc[ARKTCOMART])
                acc[ARKTCOMART] = {};
            if (!acc[ARKTCOMART][dateKey])
                acc[ARKTCOMART][dateKey] = localProductionTime.quantity;
            else
                acc[ARKTCOMART][dateKey] += localProductionTime.quantity;
            if (dateKey > maxDateKey)
                maxDateKey = dateKey;
        }
        if (scheduledResupplies) {
            scheduledResupplies.forEach(function (_a) {
                var date = _a.date, quantity = _a.quantity;
                var dateKey = dateToStringKey_1.dateToStringKey(date);
                if (!acc[ARKTCOMART])
                    acc[ARKTCOMART] = {};
                if (!acc[ARKTCOMART][dateKey])
                    acc[ARKTCOMART][dateKey] = quantity;
                else
                    acc[ARKTCOMART][dateKey] += quantity;
                if (dateKey > maxDateKey)
                    maxDateKey = dateKey;
            });
        }
        if (productionOrders) {
            productionOrders.forEach(function (_a) {
                var date = _a.date, quantity = _a.quantity;
                var dateKey = dateToStringKey_1.dateToStringKey(date);
                if (!acc[ARKTCOMART])
                    acc[ARKTCOMART] = {};
                if (!acc[ARKTCOMART][dateKey])
                    acc[ARKTCOMART][dateKey] = quantity;
                else
                    acc[ARKTCOMART][dateKey] += quantity;
                if (dateKey > maxDateKey)
                    maxDateKey = dateKey;
            });
        }
        if (supplierOrders) {
            supplierOrders.forEach(function (_a) {
                var date = _a.date, quantity = _a.quantity;
                var dateKey = dateToStringKey_1.dateToStringKey(date);
                if (!acc[ARKTCOMART])
                    acc[ARKTCOMART] = {};
                if (!acc[ARKTCOMART][dateKey])
                    acc[ARKTCOMART][dateKey] = quantity;
                else
                    acc[ARKTCOMART][dateKey] += quantity;
                if (dateKey > maxDateKey)
                    maxDateKey = dateKey;
            });
        }
        return acc;
    }, {});
    return { maxDateKey: maxDateKey, resuppliesByArticleByDay: resuppliesByArticleByDay };
}
exports.getResuppliesByArticlesByDays = getResuppliesByArticlesByDays;
